import { create } from "zustand";
import { persist } from "zustand/middleware";

type PlanturaStore = {
  client: string | null;
  traceId: string | null;
  getClient: () => string;
  getTraceId: () => string | null;
  setClient: (client: string | null) => void;
  setTraceId: (traceId: string | null) => void;
};

const usePlanturaStore = create(
  persist<PlanturaStore>(
    (set, get) => ({
      client: null,
      traceId: null,
      getClient: () => get().client || "self",
      getTraceId: () => get().traceId,
      setClient: (client) => set(() => ({ client })),
      setTraceId: (traceId) => set(() => ({ traceId })),
    }),
    {
      name: "plantura",
    },
  ),
);

export { usePlanturaStore };
